<div class="row justify-content-center">
  <div class="mb-5 col-xl-5 col-lg-5 col-md-6 col-sm-10">
    <div *ngIf="!this.loading">
      <h1 class="h3 mb-3 font-weight-normal">Perfil de usuario</h1>

      <ul class="nav nav-tabs use-app-colors">
        <li class="nav-item">
          <a class="nav-link use-app-colors" [ngClass]="{'active': this.activeTab === 1}" (click)="this.setActiveTab(1)">Datos generales</a>
        </li>
        <li class="nav-item">
          <a class="nav-link use-app-colors" [ngClass]="{'active': this.activeTab === 2}" (click)="this.setActiveTab(2)">Suscripciones</a>
        </li>
      </ul>

      <div *ngIf="this.activeTab === 1" class="mt-3">
        <div *ngIf="this.editingGeneralData">
          <div class="form-group">
            <label for="firstName">Nombres</label>
            <input id="firstName" type="text" class="form-control" name="firstName" [(ngModel)]="this.user.UserFirstName">
          </div>
          <div class="form-group">
            <label for="lastName">Apellidos</label>
            <input id="lastName" type="text" class="form-control" name="lastName" [(ngModel)]="this.user.UserLastName">
          </div>
          <div class="form-group">
            <label for="email">Correo electrónico</label>
            <input id="email" type="email" class="form-control" placeholder="" name="email" [(ngModel)]="this.user.UserEmail">
          </div>
          <div class="form-group">
            <label for="birthDate">Fecha de nacimiento</label>
            <input id="birthDate" type="date" class="form-control" name="birthDate" placeholder="dd/mm/aaaa" [(ngModel)]="this.user.UserBirthDate">
          </div>
          <div class="form-group">
            <label for="phoneNumber">Número de teléfono</label>
            <input id="phoneNumber" type="text" class="form-control" name="phoneNumber" [(ngModel)]="this.user.UserPhoneNumber">
          </div>
          <div class="form-group" *ngIf="this.user.UserPreferences && this.user.UserPreferences.length > 0">
            <label>Preferencias</label>
            <div class="form-check" *ngFor="let preference of this.user.UserPreferences">
              <input class="form-check-input" type="checkbox" id="pref-{{preference.PreferenceId}}" [(ngModel)]="preference.PreferenceIsSelected">
              <label class="form-check-label" for="pref-{{preference.PreferenceId}}">{{preference.PreferenceName}}</label>
            </div>
          </div>
          <div class="form-group">
            <label for="exampleFormControlSelect1">Equipo favorito</label>
            <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="this.selectedFavouriteTeam">
              <option *ngFor="let team of this.teams" [ngValue]="team">{{team.TeamName}}</option>
            </select>
          </div>
          <button class="use-app-colors btn btn-lg btn-primary btn-block mt-3" type="button" (click)="this.updateGeneralData()">
            <span *ngIf="!this.processing">Guardar cambios</span>
            <div *ngIf="this.processing" class="spinner-border"></div>
          </button>
          <div class="mt-2">
            <a (click)="this.switchGeneralDataAndPassword()" class="app-link">Cambiar contraseña</a>
          </div>
        </div>

        <div  *ngIf="this.editingPassword">
          <div class="form-group">
            <label for="oldPassword">Contraseña actual</label>
            <input id="oldPassword" type="password" class="form-control" name="oldPassword" [(ngModel)]="this.user.UserPassword">
          </div>
          <div class="form-group">
            <label for="newPassword">Nueva contraseña</label>
            <input id="newPassword" type="password" class="form-control" name="newPassword" [(ngModel)]="this.newPassword">
          </div>
          <div class="form-group">
            <label for="newPasswordConfirm">Repita nueva contraseña</label>
            <input id="newPasswordConfirm" type="password" class="form-control" name="newPasswordConfirm" [(ngModel)]="this.passwordConfirm">
          </div>
          <button class="use-app-colors btn btn-lg btn-primary btn-block mt-3" type="button" (click)="this.updatePassword()">
            <span *ngIf="!this.processing">Actualizar contraseña</span>
            <div *ngIf="this.processing" class="spinner-border"></div>
          </button>
          <div class="mt-2">
            <a (click)="this.switchGeneralDataAndPassword()" class="app-link">Cambiar datos generales</a>
          </div>
        </div>
      </div>
      <div *ngIf="this.activeTab === 2" class="mt-3">
        <table *ngIf="this.userSubscriptions.length > 0" class="table">
          <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Vencimiento</th>
            <th scope="col">Estado</th>
            <th scope="col">Acciones</th>
          </tr>
          </thead>
          <tbody>
          <tr
            *ngFor="let userSubscription of this.userSubscriptions"
            [ngClass]="{
              'table-danger': userSubscription.SubscriptionStatus === 'CANCELADA',
              'table-warning': userSubscription.SubscriptionStatus === 'VIGENTE',
              'table-success': userSubscription.SubscriptionStatus === 'ACTIVA'
            }"
          >
            <td>{{userSubscription.SubscriptionPlanName}}</td>
            <td>{{userSubscription.SubscriptionEndDate | date: 'yyyy-MM-dd'}}</td>
            <td>{{userSubscription.SubscriptionStatus}}</td>
            <td>
              <button *ngIf="userSubscription.SubscriptionStatus === 'ACTIVA'" type="button" class="btn btn-outline-danger" (click)="this.unsubscribeToPlan(userSubscription.SubscriptionPlanId)">
                Eliminar
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="this.userSubscriptions.length === 0" class="text-center">
          No se han encontrado suscripciones activas para este usuario.
        </div>
      </div>
    </div>

    <div *ngIf="this.loading" class="text-center">
      Cargando...
    </div>

    <div *ngIf="this.error" [innerHTML]="this.error" class="errors-container mt-3 alert alert-danger" role="alert"></div>
    <div *ngIf="this.message" [innerHTML]="this.message" class="messages-container mt-3 alert alert-success" role="alert"></div>
  </div>
</div>

